import {
  ChangeDetectorRef,
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { ActivatedRoute, Router } from '@angular/router';
import { NavigationDestinationOption } from '@soleran/application';
import { IResolvedAppRef } from '@soleran/suite';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
})
export class NavComponent implements OnInit {
  @ViewChild(TemplateRef, { static: true })
  unconfiguredRouteRef!: TemplateRef<any>;
  isHandset$: Observable<boolean> = this._bpo.observe(Breakpoints.Handset).pipe(
    map((r) => r.matches),
    shareReplay()
  );
  groups$ = this._route.data.pipe(map((d) => d[0]));

  constructor(
    private _bpo: BreakpointObserver,
    private _route: ActivatedRoute,
    private _router: Router,
    private _dialog: MatDialog
  ) {}
  ngOnInit() {}
  onNavItemClick(e: IResolvedAppRef) {
    if (e.ref.enabled) {
      const url = this._resolveUrl(e);
      if (url) {
        this._router.navigate([url]);
      } else {
        this._dialog.open(this.unconfiguredRouteRef);
      }
    } else {
      this._router.navigateByUrl(e.ref.disabledUrl);
    }
  }

  private _resolveUrl(item: IResolvedAppRef) {
    const opt = item.app.navigationDestinationOption;
    const id = item.app.navigationEntityId;
    if (opt && id) {
      const path = NavigationDestinationOption[opt];
      return `/${path}/${id}`;
    } else {
      return '';
    }
  }
}
